import { useState } from 'react';
import { useMemoizedFn } from 'ahooks';
import cn from 'classnames';
import type { MessageListItemViewModel } from '../index';
import FactoryIconUrl from './images/msg-factory.png';
const GRADIENT_BG = 'linear-gradient(-88deg, rgba(248,225,190,1) 81%, rgba(252,240,219,1) 99%)';
const SELECTED_SHADOW = '0px 0px 0px 1px rgba(178,178,178,0.1), 0px 4px 20px 0px rgba(0,0,0,0.08)';

interface FactoryMessageItemProps {
  data: MessageListItemViewModel;
  unreadCount: number;
  isSelected: boolean;
  onNavigate: (contactId: string) => void;
}

export default function FactoryMessageItem({ data, unreadCount, isSelected, onNavigate }: FactoryMessageItemProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = useMemoizedFn(() => {
    onNavigate(data.id);
  });

  const containerStyle: React.CSSProperties = {
    background: GRADIENT_BG,
    ...(isSelected ? { boxShadow: SELECTED_SHADOW } : {}),
  };

  return (
    <div
      className="relative flex items-center gap-2 px-[14px] py-[16px] rounded-[8px] cursor-pointer h-[75px]"
      style={containerStyle}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Border overlay：绝对定位，不影响内容布局 */}
      <div
        className={cn('pointer-events-none absolute inset-0 rounded-[8px] border', {
          'border-[rgba(180,83,9,0.2)]': isSelected || isHovered,
          'border-transparent': !isSelected && !isHovered,
        })}
      />
      {/* 公司图片区域（30×30，圆形） */}
      <div className="relative flex-shrink-0 w-[30px] h-[30px]">
        <div className="w-full h-full rounded-full bg-[#FFFCEC] overflow-hidden">
          <img src={FactoryIconUrl} alt={data.displayName} className="w-full h-full object-cover" />
        </div>
        {/* 未读角标（红点，位于头像右上角） */}
        {unreadCount > 0 && (
          <div
            className={cn('absolute -top-[3px] -right-[3px] w-3 h-3 rounded-full bg-[#FB2C36]', 'ring-2 ring-white')}
          />
        )}
      </div>

      {/* 内容区 */}
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        {/* 第一行：公司名 + 时间 */}
        <div className="flex items-center gap-4">
          <span className="text-sm font-medium text-[#262626] truncate flex-1 min-w-0">{data.displayName}</span>
          <span className="text-xs text-[#737373] flex-shrink-0">{data.timeDisplay}</span>
        </div>

        {/* 第二行：消息摘要 */}
        <p className="text-xs text-[#525252] truncate">{data.latestPreview}</p>
      </div>
    </div>
  );
}
